export enum ChecklistStep {
    TestWindow,
    Location,
    TechnicalReadiness,
    DateAndTime,
    Accommodations,
    RestrictedSessions,
    MakeSessionsAvailable,
    SendInvitations,
}

export enum ChecklistStepRoute {
    TestWindow            = 'test-window',
    Location              = 'location',
    TechnicalReadiness    = 'technical-readiness',
    DateAndTime           = 'dates-times',
    Accommodations        = 'accommodations',
    RestrictedSessions    = 'restricted',
    MakeSessionsAvailable = 'make-available',
    SendInvitations       = 'invitations',
}